<mat-card class="certificate_container">
  <div class="header">
    <div class="d-flex align-items-center">
      <div class="icon">
        <span class="material-symbols-outlined"> military_tech </span>
      </div>
      <span class="heading"> Certifications</span>
    </div>
    <span class="material-symbols-outlined audit_icon" >
      settings
    </span>

  </div>
  <div class="main">
    <div class="certificate_data_container">
      <div class="certificate_content">
        <div class="certificate_count">{{certificateWidgetData?.pendingCertificateCount??0}} </div>
        <div class="d-inline-flex align-items-center" (click)="planned()"> 
          <span class="color_box planned_box"></span>
          <span class="certificate_content_info" style="cursor: pointer;">Planned Certifications</span>
        </div>
      </div>
      <div class="certificate_content">
        <div class="certificate_count">{{certificateWidgetData?.completedCertificateCount??0}} </div>
        <div class="d-inline-flex align-items-center" (click)="completed()"> 
          <span class="color_box completed_box"></span>
          <span class="certificate_content_info"style="cursor: pointer;">Completed Certifications</span>
        </div>
      </div>
    </div>
    <div class="chart_content">
      <div id="chartContainer">
      </div>
    </div>
  </div>
</mat-card>
